import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioGroupComponent } from './radio-group.component';

@NgModule({
  declarations: [RadioGroupComponent],
  imports: [
    CommonModule
  ],
  exports: [RadioGroupComponent]
})
export class RadioGroupModule { }
